import { FontConfig } from "../types"

export const BODY_4XL_CONFIG: FontConfig = {
  title: "BODY/4xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 22, tw: "text-[22px]" },
    lineHeight: { px: 30, tw: "leading-[30px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 26, tw: "text-[26px]" },
    lineHeight: { px: 34, tw: "leading-[34px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 36, tw: "text-[36px]" },
    lineHeight: { px: 48, tw: "leading-[48px]" },
  },
}
